import { Badge } from '../../../components/ui/badge';
import { useAccountGroups } from './AccountGroupsBar';
import { checkedInGroup } from '../lib/groups';

/**
 * «Текст для: все · Русские · Казахские» над полями текста. Выбрана группа —
 * заголовок и описание правятся у её отмеченных пабликов разом: у русских
 * одна подпись, у казахских другая, без перебора пабликов по одному.
 */
export function TextScope({
  checked, value, selectedId, onChange,
}: {
  checked: ReadonlySet<string>;
  /** id группы или null — «все отмеченные». */
  value: string | null;
  /** Паблик в превью: группа без него не активна. */
  selectedId: string;
  /** Новая группа и паблик, который показать в превью. */
  onChange: (groupId: string | null, previewId: string | null) => void;
}) {
  const groups = useAccountGroups()
    .map((g) => ({ group: g, ids: checkedInGroup(g, checked) }))
    .filter((x) => x.ids.length > 0);
  if (!groups.length || checked.size < 2) return null;
  const active = groups.find((x) => x.group.id === value && x.ids.includes(selectedId))?.group.id ?? null;
  return (
    <div className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground" data-testid="text-scope">
      Текст для:
      <Badge variant={active ? 'outline' : 'default'} className="cursor-pointer" onClick={() => onChange(null, null)}>
        всех отмеченных
      </Badge>
      {groups.map(({ group, ids }) => (
        <Badge
          key={group.id}
          variant={active === group.id ? 'default' : 'outline'}
          className="cursor-pointer"
          onClick={() => onChange(group.id, ids.includes(selectedId) ? selectedId : ids[0])}
        >
          {group.name} · {ids.length}
        </Badge>
      ))}
    </div>
  );
}
